export default __webpack_public_path__ + "static/media/RedFilled_Big_Ribbon.2fdfe934.svg";